import isFirstName from 'app/forms/validations/isFirstName';
import isLogin from 'app/forms/validations/isLogin';
import isSurname from 'app/forms/validations/isSurname';

export const SUBSELLER_SEARCH_FORM_NAME = 'subsellerSearch-filter';

export const FIELDS = {
	subsellerFirstName: 'subsellerFirstName',
	subsellerSurname: 'subsellerSurname',
	subsellerLogin: 'subsellerLogin',
};

export default () => ({
	[FIELDS.subsellerFirstName]: {
		deepPath: [FIELDS.subsellerFirstName],
		validations: [isFirstName()],
	},
	[FIELDS.subsellerSurname]: {
		deepPath: [FIELDS.subsellerSurname],
		validations: [isSurname()],
	},
	[FIELDS.subsellerLogin]: {
		deepPath: [FIELDS.subsellerLogin],
		validations: [isLogin()],
	},
});
